import React from 'react';
import { Document, Page, Text, View, StyleSheet,Image  } from '@react-pdf/renderer';
import QRCode from 'qrcode';

const styles = StyleSheet.create({
    page:        { padding: 40, fontSize: 11, fontFamily: 'Helvetica', color: '#1a1a1a' },
    headerBox:   { border: '1px solid #333', flexDirection: 'row', padding: '10 14', marginBottom: 14 },
    headerLeft:  { flex: 1 },
    headerRight: { width: 130, alignItems: 'flex-end', justifyContent: 'center' },
    examName:    { fontSize: 13, fontFamily: 'Helvetica-Bold', marginBottom: 6 },
    headerLine:  { fontSize: 11, marginBottom: 4 },
    headerRightLine: { fontSize: 11, marginBottom: 8 },
    instrTitle:  { fontFamily: 'Helvetica-Bold', fontSize: 11, marginBottom: 6 },
    instrItem:   { fontSize: 10, marginBottom: 3, flexDirection: 'row' },
    instrNo:     { width: 18 },
    instrText:   { flex: 1 },
    sectionBox:  {  alignItems: 'center', padding: '5 0', marginTop: 16, marginBottom: 6 },
    sectionTitle:{ fontFamily: 'Helvetica-Bold', fontSize: 16},
    sectionDesc: { fontFamily: 'Helvetica-Bold', fontSize: 12, marginBottom: 8 },
    questionRow: { flexDirection: 'row', marginBottom: 6, marginTop: 4 },
    qText:       { flex: 1, fontSize: 11, lineHeight: 1.4 },
    qMark:       { width: 40, fontSize: 11, fontFamily: 'Helvetica-Bold', textAlign: 'right' },
    optionsGrid: { flexDirection: 'row', flexWrap: 'wrap', marginTop: 4, marginBottom: 4 },
    optionItem:  { width: '50%', flexDirection: 'row', marginBottom: 3 },
    optKey:      { width: 18, fontSize: 10 },
    optText:     { fontSize: 10, flex: 1 },
    answerLine:  { borderBottom: '1px dotted #aaa', height: 14, marginTop: 4, marginBottom: 6 },
    qrBox:   { marginTop: 24, alignItems: 'center' },
    qrImage: { width: 90, height: 90 },
    qrLabel: { fontSize: 9, marginTop: 4, color: '#555' },

    // Professional school header
    schoolHeader:  { alignItems: 'center', borderBottom: '2px solid #333', paddingBottom: 8, marginBottom: 8 },
    logoImg:       { width: 50, height: 50, marginBottom: 6 },
    logoBadge:     { width: 50, height: 50, borderRadius: 25, border: '2px solid #333', alignItems: 'center', justifyContent: 'center', marginBottom: 6 },
    logoBadgeText: { fontSize: 15, fontFamily: 'Helvetica-Bold', color: '#333' },
    schoolName:    { fontSize: 18, fontFamily: 'Helvetica-Bold', textAlign: 'center' },
    schoolSub:     { fontSize: 8, color: '#666', marginTop: 2 },
    examTitle:     { fontSize: 11, fontFamily: 'Helvetica-Bold', marginTop: 5, letterSpacing: 1 },
    metaRow:       { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12 },
    metaItem:      { fontSize: 11, marginBottom: 3 },
    metaBold:      { fontFamily: 'Helvetica-Bold' },

    diagramImage:  { width: 160, height: 120, marginTop: 4, marginBottom: 6 },
    diagramBox:    { border: '1px dashed #999', height: 90, width: 160, marginTop: 4, marginBottom: 6, alignItems: 'center', justifyContent: 'center', padding: 6 },
    diagramCaption:{ fontSize: 8, color: '#777', fontFamily: 'Helvetica-Oblique', textAlign: 'center' },

    stimulusBox:   { border: '1px solid #999', padding: 8, marginBottom: 10, backgroundColor: '#f7f7f7' },
    stimulusLabel: { fontSize: 9, fontFamily: 'Helvetica-Bold', color: '#555', marginBottom: 4, textTransform: 'uppercase' },
    stimulusText:  { fontSize: 10, lineHeight: 1.4 },

    matchingGrid:  { flexDirection: 'row', marginTop: 4, marginBottom: 6 },
    matchingCol:   { flex: 1 },
    matchingHead:  { fontSize: 10, fontFamily: 'Helvetica-Bold', marginBottom: 4 },
    matchingRow:   { flexDirection: 'row', marginBottom: 3 },
    matchingKey:   { width: 18, fontSize: 10 },
    matchingText:  { fontSize: 10, flex: 1 },
});

function Header({ cls, subject }) {
    return (
        <View style={styles.headerBox}>
            <View style={styles.headerLeft}>
                <Text style={styles.examName}>H.S.S Public School</Text>
                <Text style={styles.headerLine}>Class - <Text style={{ fontFamily: 'Helvetica-Bold' }}>{cls}</Text></Text>
                <Text style={styles.headerLine}>Subject - <Text style={{ fontFamily: 'Helvetica-Bold' }}>{subject}</Text></Text>
            </View>
            <View style={styles.headerRight}>
                <Text style={styles.headerRightLine}>Duration : 60 mins</Text>
                <Text style={styles.headerRightLine}>Max. Marks : ____</Text>
            </View>
        </View>
    );
}
// "All are compulsory" ya "Attempt any X out of Y" — qusToAttempt vs noOfQus (total questions) compare karke
function attemptText(sec) {
    const total = sec.questions ? sec.questions.length : sec.noOfQus;
    const toAttempt = sec.qusToAttempt;
    if (toAttempt && toAttempt < total) {
        return `Attempt any ${toAttempt} out of ${total} questions.`;
    }
    return 'All are compulsory.';
}

function GeneralInstructions({ sections }) {
    return (
        <View style={{ marginBottom: 12 }}>
            <Text style={styles.instrTitle}>General Instructions</Text>
            <View style={styles.instrItem}>
                <Text style={styles.instrNo}>1.</Text>
                <Text style={styles.instrText}>There are total {sections.length} sections and all sections are mandatory.</Text>
            </View>
            {sections.map((sec, i) => (
                <View key={i} style={styles.instrItem}>
                    <Text style={styles.instrNo}>{i + 2}.</Text>
                    <Text style={styles.instrText}>
                        SECTION-{sec.section}: {sec.questionType} type questions. {attemptText(sec)}
                    </Text>
                </View>
            ))}
         
        </View>
    );
}

const TEXT_STIMULUS_TYPES = ['Passage Stimulus Based', 'Case Stimulus Based', 'Data Stimulus Based'];

function SectionBlock({ sec }) {
    const startQ = 1;
    const endQ   = sec.questions.length;
    const needsStimulus = TEXT_STIMULUS_TYPES.includes(sec.questionType);

    return (
        <View>
            {/* Section heading box */}
            <View style={styles.sectionBox}>
                <Text style={styles.sectionTitle}>SECTION - {sec.section}</Text>
            </View>

            {/* Section description */}
            <Text style={styles.sectionDesc}>
              Questions from {startQ} to {endQ} are {sec.questionType} type questions. {attemptText(sec)}
            </Text>

            {/* Shared stimulus (Passage / Case / Data Stimulus Based) — read ONCE, applies to all questions below */}
            {sec.stimulus && (
                <View style={styles.stimulusBox} wrap={false}>
                    <Text style={styles.stimulusLabel}>Read the following and answer the questions below</Text>
                    <Text style={styles.stimulusText}>{sec.stimulus}</Text>
                </View>
            )}
            {needsStimulus && !sec.stimulus && (
                <View style={styles.stimulusBox} wrap={false}>
                    <Text style={styles.stimulusLabel}>[Stimulus text not generated — please regenerate this paper]</Text>
                </View>
            )}

            {/* Questions */}
            {sec.questions.map((q, qi) => (
                <View key={qi} wrap={false}>
                    <View style={styles.questionRow}>
                        <Text style={styles.qText}>
                            <Text style={{}}>Ques. {`${q.quesNo}  `}</Text>
                            {q.ques}
                        </Text>
                        {q.marks != null && (
                            <Text style={styles.qMark}>[{q.marks}]</Text>
                        )}
                    </View>

                    {/* Diagram — image mila to dikhाओ, warna blank box + caption (fallback) */}
                    {/* diagramBase64 ab poora data URI hai (data:image/jpeg;base64,... ya png) — backend se aata hai */}
                    {q.hasDiagram && q.diagramBase64 && (
                        <Image src={q.diagramBase64} style={styles.diagramImage} />
                    )}
                    {q.hasDiagram && !q.diagramBase64 && (
                        <View style={styles.diagramBox}>
                            <Text style={styles.diagramCaption}>[Diagram: {q.diagramCaption || 'not available'}]</Text>
                        </View>
                    )}

                    {/* Matching columns (Column A / Column B) */}
                    {q.columnA && q.columnA.length > 0 && (
                        <View style={styles.matchingGrid}>
                            <View style={styles.matchingCol}>
                                <Text style={styles.matchingHead}>Column A</Text>
                                {q.columnA.map((item, i) => (
                                    <View key={i} style={styles.matchingRow}>
                                        <Text style={styles.matchingKey}>{i + 1}.</Text>
                                        <Text style={styles.matchingText}>{item}</Text>
                                    </View>
                                ))}
                            </View>
                            <View style={styles.matchingCol}>
                                <Text style={styles.matchingHead}>Column B</Text>
                                {q.columnB.map((item, i) => (
                                    <View key={i} style={styles.matchingRow}>
                                        <Text style={styles.matchingKey}>{String.fromCharCode(65 + i)}.</Text>
                                        <Text style={styles.matchingText}>{item}</Text>
                                    </View>
                                ))}
                            </View>
                        </View>
                    )}

                    {/* MCQ options */}
                    {q.options && q.options.length > 0 && (
                        <View style={styles.optionsGrid}>
                            {q.options.map((op, i) => (
                                <View key={i} style={styles.optionItem}>
                                    <Text style={styles.optKey}>{String.fromCharCode(65 + i)})</Text>
                                    <Text style={styles.optText}>{op}</Text>
                                </View>
                            ))}
                        </View>
                    )}

                    {/* Fill blanks / Short / Long answer line */}
                    {(!q.options || q.options.length === 0) && (
                        <View style={styles.answerLine} />
                    )}
                </View>
            ))}
        </View>
    );
}
function QuestionPaperPdf({ result, cls, subject }) {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Header cls={cls} subject={subject} />
                <GeneralInstructions sections={result.sections} />
                {result.sections.map((sec, i) => (
                    <SectionBlock key={i} sec={sec} />
                ))}
            </Page>
        </Document>
    );
}

export default QuestionPaperPdf;